export default {
  delivery_location_settings: {
    title: 'Delivery & location settings',
    page_title: 'Delivery & location settings | Thanx',
  },
}
